import { Box, Stack, Typography } from '@mui/material';
import { useRef, useState } from 'react';
import { SketchPicker } from 'react-color';

import { colors } from 'src/global/styles/colors';
import useClickOutside from 'src/hooks/useClickOutside';

import { AdminNumberFormat } from './AdminNumberFormat';

interface ColorPickerProps {
  color: string;
  onColorChange: (color: string) => void;
  opacity: number;
  onOpacityChange: (opacity: number) => void;
}

export function ColorPicker({ color, onColorChange, opacity, onOpacityChange }: ColorPickerProps) {
  const [displayColorPicker, setDisplayColorPicker] = useState(false);
  const colorPickerRef = useRef<HTMLDivElement | null>(null);
  const boxColorRef = useRef<HTMLDivElement | null>(null);

  useClickOutside(boxColorRef, () => setDisplayColorPicker(false));

  const handleChangeColor = (color: any) => {
    onColorChange(color.hex);
  };

  return (
    <Stack direction={'row'} justifyContent={'space-between'} alignItems={'center'} spacing={1}>
      <Box
        ref={boxColorRef}
        onClick={() => setDisplayColorPicker(true)}
        width={'70%'}
        padding={'12px'}
        border={`1px solid ${colors.neutral015}`}
        sx={{
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
        }}>
        {displayColorPicker ? (
          <Box
            ref={colorPickerRef}
            sx={{
              position: 'absolute',
              zIndex: 2,
              bottom: 0,
            }}>
            <Box>
              {/* TO DO
              onChange opacity not effect */}
              <SketchPicker color={color} onChange={handleChangeColor} />
            </Box>
          </Box>
        ) : null}
        <Box width={'28px'} height={'28px'} bgcolor={color} />
        <Typography marginLeft={'12px'} fontSize={'14px'} lineHeight={'20px'} sx={{ color: 'white' }}>
          {color}
        </Typography>
      </Box>
      <Box width={'30%'}>
        <AdminNumberFormat
          isAllowed={values => {
            const { floatValue } = values;
            if (!floatValue) return true;
            return floatValue >= 0 && floatValue <= 100;
          }}
          value={opacity * 100}
          onValueChange={e => {
            onOpacityChange(Number(e.floatValue));
          }}
          suffix='%'
        />
      </Box>
    </Stack>
  );
}
